import request from '@/shared/api/request';

export const deleteDatabaseFirewallRules = (
  database_uuid: string,
  rules: { address: string }[],
): Promise<void> =>
  request({
    url: `/databases/${database_uuid}/firewall/`,
    method: 'DELETE',
    data: { rules },
  });
